export const SUPPORTED_LANGUAGES = ["pt", "en", "es"];

export const LANGUAGE_LABELS = {
  pt: "PT",
  en: "EN",
  es: "ES",
};

export const LANGUAGE_FLAG_CODES = {
  pt: "BR",
  en: "US",
  es: "ES",
};

export const LANGUAGE_NAMES = {
  pt: "Português",
  en: "English",
  es: "Español",
};

export const HTML_LANG = {
  pt: "pt-BR",
  en: "en",
  es: "es",
};

export function normalizeLanguage(lng) {
  if (!lng) return "pt";
  const base = lng.toLowerCase().split("-")[0];
  if (base === "pt" || base === "en" || base === "es") return base;
  return "pt";
}
